<template>
  <section class="c-heroSection">
    <div class="main-container">
      <div class="content-container">
        <div class="c-heroSection__rightBlock">
          <h1>The freedom of the skies</h1>
        </div>
        <div class="c-heroSection__flightSearch">
          <p>FLIGHTS</p>
          <div class="c-heroSection__flightSearch--topBlock">
            <div class="c-heroSection__flightSearchInputBlock--from">
              <input class="from" type="text" value="Lisbon, Lisbon (LIS), Portugal">
            </div>
            <div class="c-heroSection__flightSearchInputBlock--to">
              <input class="to" type="text" value="San Francisco, San Francisco Int. (SFO), USA">
            </div>
          </div>
          <div class="c-heroSection__flightSearch--bottomBlock">
            <div class="c-heroSection__flightSearch--dateBlock">
              <div class="c-heroSection__flightSearchInputBlock--date">
                <input class="start" type="date" value="2020-01-01">
              </div>
              <div class="c-heroSection__flightSearchInputBlock--date">
                <input class="end" type="date" value="2020-01-08">
              </div>
            </div>
            <div class="c-heroSection__flightSearch--passengersButtonBlock">
              <div class="c-heroSection__flightSearchInputBlock--passengers">
                <select>
                  <option value="1" selected>1 Adult</option>
                </select>
              </div>
              <button type="button">Search</button>
            </div>
          </div>
          <div class="c-heroSection__flightSearch--blockRadio">
            <input type="radio" id="return" name="type" checked>
            <label for="return">Return</label>
            <input type="radio" id="oneWay" name="type">
            <label for="oneWay">One way only</label>
            <input type="radio" id="multiCity" name="type">
            <label for="multiCity">Multi-city</label>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-heroSection {
  height: 500px;
  margin-top: 132px;

  .main-container {
    background-image: url('~@/assets/hero_image.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 80%;
      height: 100%;
      background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0.4) 100%);
    }
  }

  .content-container {
    justify-content: flex-end;
    position: relative;
  }

  &__rightBlock {
    max-width: 360px;
    z-index: 2;
    text-align: right;
    margin-top: -80px;

    h1 {
      font-weight: bold;
    }
  }

  &__flightSearch {
    background-color: $blue;
    width: 1000px;
    padding: $base-padding;
    position: absolute;
    margin-left: 50%;
    margin-right: 50%;
    left: -500px;
    bottom: -130px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
    border-radius: 2px;

    p {
      font-size: 24px;
      text-align: left;
      color: $orange;
      font-weight: bold;
      margin-bottom: $base-margin;
    }

    &--topBlock, &--bottomBlock {
      display: flex;
      justify-content: space-between;
      margin-bottom: $base-margin;
      width: 100%;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &--blockRadio {
      display: flex;
      width: 100%;
      align-items: center;

      input {
        display: none;

        &:checked + label::after {
          display: block;
        }
      }

      label {
        color: #FFFFFF;
        margin-right: $base-margin;
        font-size: 16px;
        line-height: 24px;
        position: relative;
        padding-left: 38px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 24px;
          height: 24px;
          background-color: #FFFFFF;
          border-radius: 24px;
        }

        &::after {
          content: '';
          position: absolute;
          top: 6px;
          left: 6px;
          width: 12px;
          height: 12px;
          background-color: $orange;
          border-radius: 12px;
          z-index: 2;
          display: none;
        }
      }
    }

    &--passengersButtonBlock {
      display: flex;
      width: calc(50% - calc(#{$base-margin} / 2));
    }

    &--dateBlock {
      display: flex;
      width: calc(50% - calc(#{$base-margin} / 2));
    }

    input {
      font-size: 20px;
      color: $blue;
      border: none;
      box-sizing: border-box;
      border-radius: 2px;

      &:last-child {
        margin-right: 0;
      }

      &[type="text"] {
        padding: calc(#{$base-padding} / 2);
        width: 100%;
      }

      &[type="date"] {
        padding: $base-padding;
        width: 225px;
        font-size: 20px;
        appearance: textfield;

        &::-webkit-inner-spin-button, &::-webkit-clear-button {
          display: none;
        }

        &::-webkit-calendar-picker-indicator {
          font-size: 16px;
        }
      }
    }

    select {
      margin-right: $base-margin;
      width: 100%;
      height: 100%;
      padding: $base-padding;
      appearance: none;
      background-color: #FFFFFF;
      border-radius: 0;
      border: none;
      font-size: 20px;
      color: $blue;
      box-sizing: border-box;
      border-radius: 2px;
    }

    button {
      border: 2px solid $orange;
      border-radius: 0;
      background-color: $orange;
      color: #FFFFFF;
      font-size: 20px;
      cursor: pointer;
      padding: 0 calc(#{$base-padding} * 4);
      transition: all 0.2s ease-in-out;
      border-radius: 2px;

      &:hover {
        background-color: #FFFFFF;
        color: $orange;
      }
    }
  }

  &__flightSearchInputBlock {

    &--from, &--to {
      width: calc(50% - calc(#{$base-margin} / 2));
      position: relative;
    }

    &--date {
      margin-right: $base-margin;
      position: relative;
    }

    &--passengers {
      width: 100%;
      margin-right: $base-margin;
      position: relative;
    }

    &--from input {
      padding-left: 55px !important;
    }
    &--to input {
      padding-left: 35px !important;
    }

    &--from::before, &--to::before {
      position: absolute;
      top: 14px;
      left: 11px;
      font-size: 14px;
      color: $grey;
      display: block;
    }

    &--from::before {
      content: 'From';
    }

    &--to::before {
      content: 'To';
    }

    &--date input {
      padding-left: 48px !important;
    }

    &--date::before {
      content: '';
      position: absolute;
      top: 20px;
      left: 11px;
      width: 24px;
      height: 24px;
      color: $grey;
      display: block;
      background-image: url('~@/assets/datepicker_icon.svg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    &--passengers select {
      padding-left: 43px !important;
    }

    &--passengers::before {
      content: '';
      position: absolute;
      top: 22px;
      left: 11px;
      width: 19px;
      height: 20px;
      color: $grey;
      display: block;
      background-image: url('~@/assets/passenger_icon.svg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

@include desktop-sm {
  .c-heroSection {
    margin-top: 72px;
  }
}

@include tablet {
  .c-heroSection {
    height: 350px;

    &__rightBlock {
      margin-top: -180px;
    }

    &__flightSearch {
      width: calc(100% - calc(#{$base-padding * 2});
      left: $base-padding;
      margin: 0 auto;
      bottom: -140px;

      &--bottomBlock {
        display: block;
      }

      &--passengersButtonBlock, &--dateBlock {
        width: 100%;
        margin-bottom: $base-margin;
      }

      p {
        font-size: 16px;
      }

      input {
        font-size: 16px;
      }

      button {
        font-size: 16px;
      }

    }

    &__flightSearchInputBlock {
      &--date {
        width: 50%;

        input[type="date"] {
          width: 100%;
          font-size: 16px;
          padding: calc(#{$base-padding / 2});
          min-height: 41px;
        }

        &::before {
          top: 10px;
          width: 20px;
          height: 20px;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      &--passengers {
        select {
          width: 100%;
          font-size: 16px;
          padding: calc(#{$base-padding / 2});
        }

        &::before {
          top: 8px;
          width: 19px;
          height: 20px;
        }
      }
    }
  }
}

@include phone {
  .c-heroSection {
    height: 710px;

    .main-container {
      height: 250px;

      &::before {
        width: 100%;
        background: linear-gradient(0, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0.4) 100%);
      }
    }

    &__rightBlock {
      margin: 0 auto;
      text-align: center;
      margin-top: -85px;
    }

    &__flightSearch {
      bottom: -430px;

      &--dateBlock, &--topBlock, &--passengersButtonBlock {
        display: block;
        width: 100%;
        margin: 0;
      }

      &--blockRadio {
        align-items: flex-start;

        label {
          font-size: 14px;
        }
      }
    }

    &__flightSearchInputBlock {
      &--date, &--from, &--to, &--passengers {
        width: 100%;
        margin-bottom: $base-margin;
      }
    }

    button {
      padding-top: calc(#{$base-padding} / 2);
      padding-bottom: calc(#{$base-padding} / 2);
    }
  }
}
</style>
